import { ProductItemStatus } from "../enums/productItems";

/** Display order for inventory summary status chips. */
export const PRODUCT_INVENTORY_STATUS_ORDER: ProductItemStatus[] = [
  ProductItemStatus.IN_STOCK,
  ProductItemStatus.RESERVED,
  ProductItemStatus.SOLD,
  ProductItemStatus.DAMAGED,
  ProductItemStatus.EXPIRED,
  ProductItemStatus.LOST,
  ProductItemStatus.CONSUMED
];

export const PRODUCT_INVENTORY_STATUS_ACCENTS: Record<
  ProductItemStatus,
  string
> = {
  [ProductItemStatus.CREATED]: "#78909c",
  [ProductItemStatus.IN_STOCK]: "#2e7d32",
  [ProductItemStatus.RESERVED]: "#ed6c02",
  [ProductItemStatus.SOLD]: "#5c6bc0",
  [ProductItemStatus.DAMAGED]: "#d32f2f",
  [ProductItemStatus.EXPIRED]: "#8d6e63",
  [ProductItemStatus.LOST]: "#6d4c41",
  [ProductItemStatus.CONSUMED]: "#7b1fa2"
};
